// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oldbill-actions {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  margin-left: 30px;
  margin-top: 15px;
}

.oldbills {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.choose-file-button-order {
  background: #32c89633;
  border: none;
  cursor: pointer;
  /* padding: 10px; */
  border-radius: 5px;
  margin-right: 20px;
}

.oldbills label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.oldbills div {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}

.upload-oldbills-file {
  background: #28bd8b33;
  border: none;
  cursor: pointer;
  /* padding: 10px; */
  border-radius: 5px;
}

.upload-oldbills-image {
  margin-left: 20px;
  background: #28bd8b33;
  border: none;
  cursor: pointer;
  /* padding: 10px; */
  border-radius: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/Css/OldBills.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".oldbill-actions {\r\n  display: flex;\r\n  /* justify-content: space-between; */\r\n  align-items: center;\r\n  margin-left: 30px;\r\n  margin-top: 15px;\r\n}\r\n\r\n.oldbills {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.choose-file-button-order {\r\n  background: #32c89633;\r\n  border: none;\r\n  cursor: pointer;\r\n  /* padding: 10px; */\r\n  border-radius: 5px;\r\n  margin-right: 20px;\r\n}\r\n\r\n.oldbills label {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.oldbills div {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 5px;\r\n}\r\n\r\n.upload-oldbills-file {\r\n  background: #28bd8b33;\r\n  border: none;\r\n  cursor: pointer;\r\n  /* padding: 10px; */\r\n  border-radius: 5px;\r\n}\r\n\r\n.upload-oldbills-image {\r\n  margin-left: 20px;\r\n  background: #28bd8b33;\r\n  border: none;\r\n  cursor: pointer;\r\n  /* padding: 10px; */\r\n  border-radius: 5px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
